export const PAGE_BREAK = /<hr\b[^>]*\sdata-page-break(?=[\s=/>])[^>]*>/;

export const removePageBreaks = (html: string) => html.replace(new RegExp(PAGE_BREAK, 'g'), '');
